export default __webpack_public_path__ + "static/media/config.a37a2518.png";